module.exports = __webpack_public_path__ + "static/media/me.52b1f52b.jpg";